module.exports = __webpack_public_path__ + "static/scale-model-of-oregon-air-and-space-museum-in-eugene-oregon-f3e39a1a6e3335573a2e3c863dacfde0.png";